Ext.define('SA.view.sidebar.data.YearFacetRadioGroup', {
    alias: 'widget.data-search-year-radio-group',
    extend: 'Ext.Component',

    cls: 'sa-sidebar-data-radio-group',

    tpl: [
        '<div class="sa-sidebar-data-radio-group-title">Year</div>',
        '<div class="sa-sidebar-data-radio-group-body">',
            '<tpl for="groups">',
                '<div class="sa-sidebar-data-radio-group-section-title">{sectionTitle}</div>',
                '<tpl for="values">',
                    '<tpl if="beginsCollapse">',
                        '<div class="sa-sidebar-data-radio-collapsible-section">',
                    '</tpl>',
                            '<button data-value="{year}" class="sa-sidebar-data-radio sa-sidebar-data-section-radio',
                                '<tpl if="selected"> sa-sidebar-data-radio-selected</tpl>',
                            '">',
                                '<span class="sa-sidebar-data-radio-button"></span>',
                                '<span class="sa-sidebar-data-radio-label">{year}</span>',
                                ' ',
                                '<span class="sa-sidebar-data-radio-count">({count})</span>',
                            '</button>',
                    '<tpl if="endsCollapse">',
                            '<div class="sa-sidebar-data-radio-open-link">...more</div>',
                        '</div>', 
                    '</tpl>',
                '</tpl>',
            '</tpl>',
        '</div>'
    ],

    getGroupTypeForYear(year) {
        var currentYear = new Date().getFullYear();

        if (year === 'Latest') {
            return 'latest';
        }

        return year > currentYear ? 'future' : (year <= 2009 ? 'historical' : 'current');
    },

    getSelected() {
        return this.selected;
    },

    initEvents() {
        var el = this.el;

        this.callParent();

        el.on({
            delegate: '.sa-sidebar-data-radio',
            scope: this,

            click: this.onItemClick,
            mouseout: this.onMouseOut,
            mouseover: this.onMouseOver
        });

        el.on({
            delegate: '.sa-sidebar-data-radio-open-link',
            scope: this,

            click: this.onMoreLinkClick
        });
    },

    onItemClick(ev, el) {
        var value = el.getAttribute('data-value');

        if (value) {
            this.setSelected(value);
        }
    },

    onMoreLinkClick(ev, el) {
        Ext.fly(el).up('.sa-sidebar-data-radio-collapsible-section')
            .addCls('sa-sidebar-data-radio-collapsible-section-opened');
    },

    onMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-sidebar-data-radio-over');
    },

    onMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-sidebar-data-radio-over');
    },

    refresh() {
        var me = this,
            selected = this.selected,
            hasValues = !!this.groupedValues,
            groups = Ext.clone(this.groupedValues) || {};

        if (selected && hasValues) {
            setOrAddSelectedValue();
        }

        this.update({groups: getTplData()});

        function getTplData() {
            var data = [
                {sectionTitle: 'Latest Release', values: groups.latest},
                {sectionTitle: 'Current and Recent', values: groups.current},
                {sectionTitle: 'Projections', values: groups.future},
                {sectionTitle: 'Historical', values: groups.historical}
            ];

            return Ext.Array.filter(data, function(group) {
                    return group.values && group.values.length;
                })
                .map(setCollapsibleProperties);
        }

        function setCollapsibleProperties(section) {
            var values = section.values,
                selectedValue = values.find(value => value.year === selected),
                selectedIndex = values.indexOf(selectedValue),
                collapseAtIndex = Math.max(5, (selectedIndex || 0) + 1),
                lastIndex = values.length - 1;

            if (collapseAtIndex < lastIndex) {
                values[collapseAtIndex].beginsCollapse = true;
                values[lastIndex].endsCollapse = true;
            }

            return section;
        }

        function setOrAddSelectedValue() {
            var allPairs = Ext.Array.flatten(Object.values(groups)),
                matchedPair = allPairs.find(pair => pair.year == selected);

            if (matchedPair) {
                matchedPair.selected = true;
            } else {
                addSelectedValue();
            }

            function addSelectedValue() {
                var relevantGroup = groups[me.getGroupTypeForYear(selected)];

                relevantGroup.push({
                    year: selected,
                    count: 0,
                    selected: true
                });

                relevantGroup.sort(me.sortReverseChronologically);
            }
        }
    },

    setSelected(selected) {
        if (this.selected !== selected) {
            this.selected = selected;

            this.refresh();

            this.fireEvent('select', this, selected);
        }
    },

    setValues(values) {
        var me = this;

        this.groupedValues = groupValues(values);

        this.refresh();

        function groupValues(values) {
            var groups = {latest: [], current: [], future: [], historical: []};

            Object.keys(values)
                .map(year => ({year, count: values[year]}))
                .sort(me.sortReverseChronologically)
                .forEach(pair => {
                    groups[me.getGroupTypeForYear(pair.year)].push(pair);
                });

            return groups;
        }
    },

    sortReverseChronologically(pair1, pair2) {
        var year1 = pair1.year,
            year2 = pair2.year;

        if (year1 === 'Latest') {
            return -1;
        }
        else if (year2 === 'Latest') {
            return 1;
        }
        else {
            return year2 - year1;
        }
    }
});